import React from 'react';

interface FormCardProps {
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  title?: string;
  // eslint-disable-next-line react/require-default-props
  subtitle?: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

const FormCard: React.FC<FormCardProps> = ({
  children,
  title,
  subtitle,
  className = '',
}) => {
  return (
    <div className={`bg-white rounded-2xl p-8 shadow-sm ${className}`}>
      {title && (
        <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="text-sm text-gray-500 text-center mb-8">{subtitle}</p>
      )}
      {children}
    </div>
  );
};

export default FormCard;
